<template>
  <span style="font-weight: 700;" class="secondary_title">
    {{small}}
    <sup v-if="sup" style="margin-left:-3px" class="secondary_title">{{sup}}</sup>
  </span>
</template>

<script>
export default {
  props: ["price"],
  data() {
    return {
      small: "",
      sup: ""
    };
  },
  watch: {
    price: {
      handler() {
        let str = this.price.toString();
        let arr = str.split(".");
        this.small = arr[0];
        this.sup = arr[1];
      },
      immediate: true
    }
  }
};
</script>

<style>
</style>